import { render, staticRenderFns } from "./PutawayConfirm.vue?vue&type=template&id=83c0f762"
import script from "./PutawayConfirm.vue?vue&type=script&lang=js"
export * from "./PutawayConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports